import CompLayout from "@/pcomponents/comp/layout/layout";
import CompStuPrescribeListArea from "@/pages/comp/edu/comp_stu_prescribe/common/list";

function ManageListPage(props: any) {
  let myProps = {
    ...props
  };

  return (
    <CompLayout>
      <CompStuPrescribeListArea></CompStuPrescribeListArea>
    </CompLayout>
  );
};
export default ManageListPage;